import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import Dashboard from "../Pages/Dashboard";

// Import Authentication pages
import Login from "../Pages/Authentication/Login";
import ForgetPasswordPage from "../Pages/Authentication/ForgetPassword";
import ForgotPassword from "../Pages/Authentication/ForgotPassword";
import EmployeeForgotPassword from "../Pages/Authentication/EmployeeForgotPassword";
import OTPVerification from "../Pages/Authentication/OTPVerification";
import ResetPassword from "../Pages/Authentication/ResetPassword";
import Logout from "../Pages/Authentication/Logout";
import Register from "../Pages/Authentication/Register";
import UserProfile from "../Pages/Authentication/user-profile";
import Users from "../Pages/Users";
import UserDetails from "../Pages/Users/UserDetails";
import Hotels from "../Pages/Hotels/Hotels";
import RequestHotel from "../Pages/Request/RequestHotel";
import HotelMenu from "../Pages/Menu/addmenu";
import Customermenu from "../Pages/Customermenu/CustomerMenu";
import Menudetails from "../Pages/Customermenu/Menudetails";
import Reservations from "../Pages/Reservations/Reservations";
import EmployeeLogin from "../Pages/Authentication/EmployeeLogin";
import Guest from "../Pages/Guest/Guest";
import Rooms from "../Pages/Rooms/Room";
import SpaAppointment from "../Pages/Spa/SpaAppointment";
import GuestDetails from "../Pages/Guest/GuestDetails";
import Hotelnsights from "../Pages/hoteldetails/hotelnsights";

import SpaServices from "../Pages/Spa/SpaServices";
import HotelDetails from "../Pages/hoteldetails/HotelDetails.js";
import RoomHistory from "../Pages/Rooms/RoomHistory"
import ReservationDetails from "../Pages/Reservations/ReservationDetails";
import SubAdmin from "../Pages/SubAdmin/SubAdmin";

// Import Static Pages
import PrivacyPolicy from "../Pages/StaticPages/PrivacyPolicy";
import PrivacyPolicyPage from "../Pages/StaticPages/PrivacyPolicyPage";
import TermsConditions from "../Pages/StaticPages/TermsConditions";
import TermsConditionsPage from "../Pages/StaticPages/TermsConditionsPage";
import ContactUs from "../Pages/ContactUs/ContactUs";
import ContactUsListing from "../Pages/ContactUs/ContactUsListing";
import HotelInvoice from "../Pages/Hotels/HotelBill.js";

const authProtectedRoutes = [
  //dashboard
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/Users", component: <Users /> },

  { path: "/hotels", component: <Hotels /> },
  { path: "/hotels-details/:hotel_id", component: <HotelDetails /> },
  { path: "/hotel-insights", component: <Hotelnsights /> },

  { path: "/pendinghotels", component: <RequestHotel /> },
  { path: "/users", component: <Users /> },
  { path: "/users/:EmployeeID", component: <UserDetails /> },
  // User Profile

  // Profile
  { path: "/userprofile", component: <UserProfile /> },

  // hotel menu
  { path: "/hotelmenu", component: <HotelMenu /> },
  { path: "/Customer-menu", component: <Customermenu /> },
  { path: "/addmenu-details/:id", component: <Menudetails /> },

  // Reservations and Rooms
  { path: "/guest", component: <Guest /> },
  { path: "/guest/:id", component: <GuestDetails /> },
  { path: "/reservations", component: <Reservations /> },
  { path: "/reservation/:reservationId", component: <ReservationDetails /> },
  { path: "/rooms", component: <Rooms /> },
  { path: "/room-history/:roomId/:roomNumber", component: <RoomHistory /> },
  { path: "/spa", component: <SpaAppointment /> },
  { path: "/spaService", component: <SpaServices /> },
  {path:"/invoice/:id", component:<HotelInvoice/>},
  { path: "/sub-admin", component: <SubAdmin /> },
  { path: "/contact-messages", component: <ContactUsListing /> },
  { path: "/terms-conditions-page", component: <TermsConditionsPage /> },
  { path: "/privacy-policy-page", component: <PrivacyPolicyPage /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  {
    path: "/",

    component: <Navigate to="/Users" />,
  },
  {
    path: "/hotel-details/:id",
    element: <HotelDetails />,
  },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/EmployeeLogin", component: <EmployeeLogin /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
  { path: "/employee-forgot-password", component: <EmployeeForgotPassword /> },
  { path: "/verify-otp", component: <OTPVerification /> },
  { path: "/reset-password", component: <ResetPassword /> },
  { path: "/register", component: <Register /> },
  // Static Pages
  { path: "/privacy-policy", component: <PrivacyPolicy /> },
  { path: "/terms-conditions", component: <TermsConditions /> },
  { path: "/contact-us", component: <ContactUs /> },
];

export { authProtectedRoutes, publicRoutes };
